import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import DayBookTable from './DayBookTable';

 
const index = () => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">Day Wise Report</h3>
      </Col>
    </Row>
    <Row>
      <DayBookTable />
    </Row>
  </Container>
  );
 
export default index;
